// Backend types
export const AGILITY_BOARD = 'agility-board' as const;
const CORE_BOARD = 'core-board' as const;
export const KANBAN_BOARD = 'kanban' as const;
export const SCRUM_BOARD = 'scrum' as const;

export type BoardType =
	| typeof AGILITY_BOARD
	| typeof CORE_BOARD
	| typeof KANBAN_BOARD
	| typeof SCRUM_BOARD;
